import PropTypes from 'prop-types';

export default {
  'aria-label': PropTypes.string,
  'aria-haspopup': PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  'aria-controls': PropTypes.string,
  'aria-expanded': PropTypes.bool,
};
